
import { useState, useEffect } from "react";
import axios from "axios";
import { FaChartLine, FaSearch } from 'react-icons/fa';
import AssignedExamsCard from "./Components/AssignedExamsCard";
import "./NewEmpDashboard.css";
import LeaderboardCard from "../User/Dashboard/LeaderboardCard";
import '../Final_Css/positiveflowbuttons.css';
import MyLeaderboardCard from './Components/MyLeaderboardCard';
import DashboardPerformanceAnalytics from "./Components/DashboardPerformanceAnalytics";
import GuidedTour from "../TempUser/GuidedTour";
import { fullTourSteps } from "../TempUser/tourSteps";
import { useNavigate, useLocation, useOutletContext, Navigate } from "react-router-dom";
import TheoryAnalytics from "../TempUser/TheoryAnalytics";   // adjust path
import VivaAnalytics from "../TempUser/VivaAnalytics";       // adjust path

export const NewEmpDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showTour, setShowTour] = useState(false);
  const [tourStepIndex, setTourStepIndex] = useState(0);
  const [userName, setUserName] = useState('');
  const [loading, setLoading] = useState(true);
  const [activeMainTab, setActiveMainTab] = useState("total");
  const [activeSubTab, setActiveSubTab] = useState("overview");
  const [filterType, setFilterType] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [audioMetrics, setAudioMetrics] = useState({});
  const [videoMetrics, setVideoMetrics] = useState({});
  const [userRole, setUserRole] = useState(null);
  const [leaderboardView, setLeaderboardView] = useState("global");
  const [showDemoDropdown, setShowDemoDropdown] = useState(false);
  const [analyticsType, setAnalyticsType] = useState("theory");
  const [courses, setCourses] = useState([]);
  const [examStatus, setExamStatus] = useState("");
  const [exams, setExams] = useState([]);
  const [totalCompleted, setTotalCompleted] = useState(0);
  const [serverTime, setServerTime] = useState(null);
  const [kpiValues, setKpiValues] = useState({
    "Assigned Exams": null,
    "Pending": null,
    "Avg": null,
    "Acc": null,
    "Completed Exams": null,
    "Missed": null
  });

  useEffect(() => {
    if (location.state?.resumeTour && typeof location.state.stepIndex === "number") {
      setTourStepIndex(location.state.stepIndex);
      // Optional: make sure tour is visible
      // setShowTour(true); // ← only if you still use this state
    }
  }, [location.state]);

  const handleTourFinish = () => {
    setShowTour(false);
    setTourStepIndex(0);
  };
  const { permissionSet, permissionsLoading } = useOutletContext();

  const canAccessAssessment = permissionSet.has(9);


  useEffect(() => {
    let isMounted = true;
    const minLoadingTime = 4000;
    const startTime = Date.now();

    const fetchUserData = async () => {
      try {
        const response = await axios.get('/api/payload/', {
          withCredentials: true,
        });
        const data = response.data;

        if (isMounted && data?.payload) {
          const fullName = `${data.payload.first_name || ''} ${data.payload.last_name || ''}`.trim();
          setUserName(fullName || 'User');

          const role = data.payload.role_id?.toString();
          if (role) {
            setUserRole(role);
            sessionStorage.setItem('user_role', role);
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        setUserName('User');

        const savedRole = sessionStorage.getItem('user_role');
        if (savedRole) setUserRole(savedRole);
      } finally {
        if (isMounted) {
          const elapsed = Date.now() - startTime;
          const delay = Math.max(0, minLoadingTime - elapsed);
          setTimeout(() => {
            if (isMounted) setLoading(false);
          }, delay);
        }
      }
    };

    fetchUserData();
  }, []);

  console.log("FDDDDDD")
 const fetchAssignedExams = async () => {
  try {
    const res = await axios.get("/employee/assigned-exams/", {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = res.data;

    setServerTime(data.serverTime);

    const mapped = (data.exams || []).map(e => ({
      id: e.Id,
      title: e.ExamTitle,
      due: e.SheduledStartTime
        ? new Date(e.SheduledStartTime).toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          })
        : "N/A",
      type: e.ExamType || "Unknown",
      status: e.IsActive ? "Not Started" : "Inactive",
      ee_id: e.ExamEmployeeId,
      area: e.Area,
      topic: e.Topic,
      subtopic: e.SubTopic,
      examPurpose: e.exampurpose,
      SheduledEndTime: e.SheduledEndTime,
      SheduledStartTime: e.SheduledStartTime,
      examStatus: e.Status,
      attemptCount: e.UserAttemptCount,
      raw: e,
    }));

    setCourses(mapped);
    sessionStorage.setItem("assignedExams", JSON.stringify(data));
  } catch (err) {
    console.error(err);
    setCourses([]);
  }
};

  useEffect(() => {
    fetchAssignedExams(); // First load

    const interval = setInterval(() => {
      fetchAssignedExams(); // Refresh every 5 seconds
    }, 500);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    axios.get("/dashboard/get_exams/", { withCredentials: true })
      .then(res => {
        const fetchedExams = res.data.exams || [];
        setExams(fetchedExams);
        if (fetchedExams.length > 0) setSelectedExam(fetchedExams[0].ExamDetails?.examEmployeeId || "");
      })
      .catch(err => console.error("Failed to fetch exams:", err));
  }, []);

  useEffect(() => {
    if (!selectedExam) return;

    axios.get(`/dashboard/audio/?examId=${selectedExam}`, { withCredentials: true })
      .then(res => {
        setAudioMetrics(res.data.audio_metrics || {});
        setVideoMetrics(res.data.video_metrics || {});
      })
      .catch(console.error);
  }, [selectedExam]);

  useEffect(() => {
    const fetchKpiSummary = async () => {
      try {
        const res = await axios.get("/dashboard/summary/", {
          withCredentials: true,
        });
        const data = res.data;

        setKpiValues(prev => ({
          ...prev,
          "Assigned Exams": data.assigned,
          "Pending": data.pending,
          "Avg": data.averageScore,
          "Acc": data.accuracy,
          "Missed": data.missed
        }));
      } catch (err) {
        console.error("Error loading KPI summary:", err);
      }
    };

    fetchKpiSummary();
  }, []);

  useEffect(() => {
    const fetchCompletedCount = async () => {
      try {
        const res = await axios.post(
          `/dashboard/completed/`,
          { filter: "month", offset: 0 },
          {
            withCredentials: true,
            headers: { "Content-Type": "application/json" },
          }
        );
        const result = res.data;
        setTotalCompleted(Number(result?.completed_total) || 0);
      } catch (err) {
        console.error("ERROR:", err);
        setTotalCompleted(0);
      }
    };
    fetchCompletedCount();
  }, []);

  const handleStartExam = async (courses) => {
    const selectedExam = courses.raw || courses;
    console.log(selectedExam, "GGg")

    try {
      await axios.post(
        `/employee/set-exam-cookie/`,
        {
          exam_id: selectedExam.Id,
          exam_employee_id: selectedExam.ExamEmployeeId,
          exam_title: selectedExam.ExamTitle,
          exam_purpose: selectedExam.ExamPurpose,
        },
        { withCredentials: true }
      );
    } catch (error) {
      console.error("Error setting exam cookies:", error);
      alert(error.response?.data?.error || "Failed to set exam cookies");
    }

    if (courses.type === "Objective Assessment") {
      navigate("/instructions", {
        state: {
          ExamEmployeeId: selectedExam.ExamEmployeeId,
          examId: selectedExam.Id,
          ExamTitle: selectedExam.ExamTitle,
          examPurpose: selectedExam.exampurpose,
          status: selectedExam.Status,
          area: courses.area,
          topic: courses.topic,
          subtopic: courses.subtopic,
        },
      });
      return;
    }

    if (courses.type === "Competency Review") {
      try {
        navigate(`/instructions/${courses.ee_id}`, {
          state: {
            ExamEmployeeId: selectedExam.ExamEmployeeId,
            examId: selectedExam.Id,
            ExamTitle: selectedExam.ExamTitle,
            examPurpose: selectedExam.exampurpose,
            status: selectedExam.Status, // <-- add this
          },
        });
        ;
      } catch (error) {
        console.error("Error fetching Viva questions:", error);
        alert("Error fetching questions. Please try again.");
      }
    }
  };

  if (permissionsLoading) return <div>Loading...</div>;

  if (!canAccessAssessment) {
    return <Navigate to="/error" replace />;
  }
  return (
    <>
      {tourStepIndex !== null && tourStepIndex >= 0 && (
        <GuidedTour
          steps={fullTourSteps}
          stepIndex={tourStepIndex}
          setStepIndex={setTourStepIndex}
          onFinish={handleTourFinish}
        />
      )}
      <div className="emp-dashboard-container">
        <div className="emp-main-content emp-expanded">
          <div className="emp-top-section-container">
            <div className="emp-left-column-container">
              {/* Welcome Card */}
              <section className="emp-welcome-card">
                <div className="emp-welcome-illustration"></div>
                <div className="emp-welcome-content">
                  <div className="emp-welcome-text">
                    <h1>Hello {loading ? '...' : userName || 'User'}, Welcome Back!</h1>
                    <p>Track your learning progress, measure your skills, and empower your growth — all in one place.</p>
                  </div>
                </div>
              </section>

              {/* Minimalist Tabs */}
              <div className="emp-minimal-tabs-container">
                <button
                  className={`emp-minimal-tab emp-total-tab ${activeMainTab === "total" ? "emp-active" : ""}`}
                  onClick={() => setActiveMainTab("total")}
                >
                  <div className="emp-minimal-tab-info">
                    <span className="emp-minimal-tab-name">Total Assessments</span>
                    <span className="emp-minimal-tab-count">{kpiValues["Assigned Exams"] || 0}</span>
                  </div>
                  <div className="emp-minimal-tab-image"></div>
                </button>

                <button
                  className={`emp-minimal-tab emp-pending-tab ${activeMainTab === "pending" ? "emp-active" : ""}`}
                  onClick={() => setActiveMainTab("pending")}
                >
                  <div className="emp-minimal-tab-info">
                    <span className="emp-minimal-tab-name">Pending Assessments</span>
                    <span className="emp-minimal-tab-count">{kpiValues["Pending"] || 0}</span>
                  </div>
                  <div className="emp-minimal-tab-image"></div>
                </button>

                <button
                  className={`emp-minimal-tab emp-completed-tab ${activeMainTab === "completed" ? "emp-active" : ""}`}
                  onClick={() => setActiveMainTab("completed")}
                >
                  <div className="emp-minimal-tab-info">
                    <span className="emp-minimal-tab-name">Completed Assessments</span>
                    <span className="emp-minimal-tab-count">{totalCompleted}</span>
                  </div>
                  <div className="emp-minimal-tab-image"></div>
                </button>
                <button
                  className={`emp-minimal-tab emp-missed-tab ${activeMainTab === "completed" ? "emp-active" : ""}`}
                  onClick={() => setActiveMainTab("completed")}
                >
                  <div className="emp-minimal-tab-info">
                    <span className="emp-minimal-tab-name">Missed Assessments</span>
                    <span className="emp-minimal-tab-count">{kpiValues["Missed"] || 0}</span>
                  </div>
                  <div className="emp-minimal-tab-image"></div>
                </button>
              </div>
            </div>

            <DashboardPerformanceAnalytics />

          </div>

          {/* Sub-tabs Container */}
          <div className="emp-sub-tabs-container">
            <div className="emp-dashboard-header-controls">
              {/* Left: Main Tabs */}
              <div className="emp-sub-tabs">
                <button
                  className={`emp-sub-tab ${activeSubTab === "overview" ? "btn" : ""}`}
                  onClick={() => setActiveSubTab("overview")}
                >
                  Overview
                </button>
                <button
                  className={`emp-sub-tab ${activeSubTab === "analytics" ? "btn" : ""}`}
                  onClick={() => setActiveSubTab("analytics")}
                >
                  Analytics
                </button>
                <button
                  className={`emp-sub-tab ${activeSubTab === "leaderboards" ? "btn" : ""}`}
                  onClick={() => setActiveSubTab("leaderboards")}
                >
                  Leaderboards
                </button>
              </div>


              {/* Right Controls */}
              <div className="emp-right-controls">
                {activeSubTab === "overview" && (
                  <>
                    <div className="emp-search-bar-compact">
                      <FaSearch className="emp-search-icon" />
                      <input
                        type="text"
                        placeholder="Search assessments..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="emp-search-input"
                      />
                    </div>

                    <div className="emp-filter-buttons-compact">
                      <button
                        className={`emp-filter-btn ${filterType === "all" ? "btn" : ""}`}
                        onClick={() => setFilterType("all")}
                      >
                        All
                      </button>
                      <button
                        className={`emp-filter-btn ${filterType === "Objective Assessment" ? "btn" : ""}`}
                        onClick={() => setFilterType("Objective Assessment")}
                      >
                        Objective Assessment
                      </button>
                      <button
                        className={`emp-filter-btn ${filterType === "Competency Review" ? "btn" : ""}`}
                        onClick={() => setFilterType("Competency Review")}
                      >
                        Competency Review
                      </button>
                    </div>
                  </>
                )}

                {activeSubTab === "leaderboards" && (
                  <div className="emp-leaderboard-sub-tabs">
                    <button
                      className={`emp-leaderboard-sub-tab ${leaderboardView === "global" ? "btn" : ""}`}
                      onClick={() => setLeaderboardView("global")}
                    >
                      Global Leaderboard
                    </button>
                    <button
                      className={`emp-leaderboard-sub-tab ${leaderboardView === "my" ? "btn" : ""}`}
                      onClick={() => setLeaderboardView("my")}
                    >
                      My Leaderboard
                    </button>
                  </div>
                )}

                {activeSubTab === "analytics" && <div style={{ width: "280px" }}></div>}
              </div>
            </div>
          </div>

          {/* Tab Content */}
          {activeSubTab === "overview" && (
            <div className="emp-exams-grid">
              <AssignedExamsCard
                courses={courses}
                serverTime={serverTime}
                handleStartExam={handleStartExam}
                searchQuery={searchQuery}
                filterType={filterType}
              />
            </div>
          )}

          {activeSubTab === "analytics" && (
            <div className="pd-dashboard">
              <div className="analytics-type-tabs" style={{ display: "flex", gap: "12px", marginBottom: "24px", borderBottom: "2px solid var(--pd-border)" }}>
                <button
                  onClick={() => setAnalyticsType("theory")}
                  style={{
                    padding: "10px 24px",
                    background: analyticsType === "theory" ? "#6366f1" : "transparent",
                    color: analyticsType === "theory" ? "white" : "var(--pd-muted)",
                    border: "none",
                    borderRadius: "8px 8px 0 0",
                    cursor: "pointer",
                    fontWeight: 600,
                    transition: "all 0.2s",
                    borderBottom: analyticsType === "theory" ? "2px solid #6366f1" : "none"
                  }}
                >
                  📊 Objective Analytics
                </button>
                <button
                  onClick={() => setAnalyticsType("viva")}
                  style={{
                    padding: "10px 24px",
                    background: analyticsType === "viva" ? "#8b5cf6" : "transparent",
                    color: analyticsType === "viva" ? "white" : "var(--pd-muted)",
                    border: "none",
                    borderRadius: "8px 8px 0 0",
                    cursor: "pointer",
                    fontWeight: 600,
                    transition: "all 0.2s"
                  }}
                >
                  🎙️ Competency Review Analytics
                </button>
              </div>

              {analyticsType === "theory" && <TheoryAnalytics />}
              {analyticsType === "viva" && <VivaAnalytics />}
            </div>
          )}

          {activeSubTab === "leaderboards" && (
            <div className="pd-dashboard">
              <div className="emp-leaderboard-container">
                <div className="emp-leaderboard-content">
                  {leaderboardView === "global" && <LeaderboardCard />}

                  {leaderboardView === "my" && <MyLeaderboardCard />}
                </div>
              </div>
            </div>

          )}
        </div>
      </div>
    </>

  );
};

export default NewEmpDashboard;


